module.exports = __webpack_public_path__ + "img/6.eb89f162.jpg";